// Saving a cloud as a custom preset the researcher can pour another cloud into.
//
// The route hangs off the report the page is on -- /:section/:report -- which is not handed down
// to a block, so it is read off the location the way the page itself addresses it.

import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

const saveUrl = () => {
  const [, section, report] = window.location.pathname.split('/')

  return `/${section}/${report}/save_wc_preset`
}

export const saveWcPreset = async ({ questionKey, preset }) =>
  railsPostFetch(saveUrl(), { body: JSON.stringify({ data: preset, q: questionKey }) }).then(response =>
    response.json()
  )
